import React, { useState, useMemo } from "react";
import "./ColdwaveDashboard.css";

const ColdWaveAffectedPopupData = ({ blockData }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const totalCount = blockData?.reduce((sum, block) => sum + (block.count || 0), 0);

  const filteredData = useMemo(() => {
    if (!blockData || blockData.length === 0) return [];
    if (!searchTerm.trim()) return blockData;
    return blockData.filter((block) =>
      block.block_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [blockData, searchTerm]);

  const filteredTotal = filteredData.reduce((sum, block) => sum + (block.count || 0), 0);

  if (!blockData || blockData.length === 0) {
    return (
      <div className="cwd-popup-empty">
        <div className="cwd-popup-empty-text">No block-level data available</div>
      </div>
    );
  }

  return (
    <>
      {/* Search input */}
      <div className="cwd-popup-search">
        <svg className="cwd-popup-search-icon" viewBox="0 0 16 16" fill="none" width="14" height="14">
          <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M11 11l3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        <input
          type="text"
          placeholder="Search blocks..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button
            onClick={() => setSearchTerm("")}
            style={{
              background: "none", border: "none", cursor: "pointer",
              color: "#7A9BB0", fontSize: 14, padding: 0, lineHeight: 1,
            }}
          >✕</button>
        )}
      </div>

      {/* Results */}
      {filteredData.length === 0 ? (
        <div className="cwd-popup-empty">
          <div className="cwd-popup-empty-text">No blocks match "{searchTerm}"</div>
        </div>
      ) : (
        <>
          {filteredData.map((block, i) => (
            <div key={i} className="cwd-popup-row">
              <div className="cwd-popup-row-left">
                <div className="cwd-popup-row-num">{i + 1}</div>
                <span>{block.block_name}</span>
              </div>
              <div className="cwd-popup-row-badge">
                {(block.count || 0).toLocaleString("en-IN")}
              </div>
            </div>
          ))}

          {/* Total row */}
          <div className="cwd-popup-row cwd-popup-row--total">
            <div className="cwd-popup-row-left">
              <div className="cwd-popup-row-num" style={{ background: "#2A6591", color: "#fff" }}>Σ</div>
              <span style={{ fontWeight: 700 }}>
                {searchTerm ? `FILTERED TOTAL (${filteredData.length})` : "TOTAL"}
              </span>
            </div>
            <div className="cwd-popup-row-badge" style={{ background: "#1C4E72" }}>
              {(searchTerm ? filteredTotal : totalCount || 0).toLocaleString("en-IN")}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ColdWaveAffectedPopupData;